import React from 'react';

const Context = React.createContext<string>('map');

export default Context;
